// extracted by mini-css-extract-plugin
export default {"main":"PurchaseSubscriptionComplete_main__+2ytH","checkIcon":"PurchaseSubscriptionComplete_checkIcon__NawIF"};